'use client';

import { GridItem, LayoutGrid, TypographyV3 } from '@jouzen/ecom-components';
import Link from 'next/link';
import { useLocale, useTranslations } from 'next-intl';

const Content = (): JSX.Element => {
  const locale = useLocale();
  const t = useTranslations();

  return (
    <section data-cy="eu-declarations-of-conformity">
      <LayoutGrid>
        <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main' }}>
          <TypographyV3 Element="h1" variant="h3">
            {t('eu_declarations_of_conformity')}
          </TypographyV3>
          <TypographyV3 variant="h6" className="mb-8">
            {t('eu_declaration_page_access')}
          </TypographyV3>
          <TypographyV3 className="mb-4 underline">
            <Link href={`/${locale}/declarations-of-conformity/gen3`}>
              {t('eu_declaration_gen_3')}
            </Link>
          </TypographyV3>
          <TypographyV3 className="underline">
            <Link href={`/${locale}/declarations-of-conformity/oura-ring-4`}>
              {t('eu_declaration_gen_4')}
            </Link>
          </TypographyV3>
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default Content;
